(function () {
  'use strict';

  const trigger = document.getElementById('gsReelTrigger');
  const modal   = document.getElementById('gsReelModal');
  if (!trigger || !modal) return;

  // Move modal to <body> so no parent stacking context breaks position:fixed
  document.body.appendChild(modal);

  const backdrop = document.getElementById('gsReelBackdrop');
  const closeBtn = document.getElementById('gsReelClose');
  const muteBtn  = document.getElementById('gsReelMute');
  const atcBtn   = document.getElementById('gsReelAtc');
  const video    = document.getElementById('gsReelVideo');
  const iframe   = document.getElementById('gsReelIframe');
  const iconMuted   = document.getElementById('gsIconMuted');
  const iconUnmuted = document.getElementById('gsIconUnmuted');

  let muted = true;

  function syncMuteIcon() {
    if (iconMuted)   iconMuted.style.display   = muted ? '' : 'none';
    if (iconUnmuted) iconUnmuted.style.display = muted ? 'none' : '';
  }

  // ── Open ──────────────────────────────────────────────────────────
  function openModal() {
    modal.classList.add('gs-reel-modal--open');
    document.body.style.overflow = 'hidden';

    if (video) {
      video.muted = true;
      muted = true;
      syncMuteIcon();
      video.currentTime = 0;
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function() {
          // autoplay blocked – user must tap mute btn to unmute anyway
        });
      }
    }
    if (iframe) {
      iframe.src = iframe.dataset.src;
    }
  }

  // ── Close ─────────────────────────────────────────────────────────
  function closeModal() {
    modal.classList.remove('gs-reel-modal--open');
    document.body.style.overflow = '';

    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    if (iframe) {
      iframe.src = '';
    }
  }

  // ── Mute toggle ───────────────────────────────────────────────────
  if (muteBtn && video) {
    muteBtn.addEventListener('click', function () {
      muted = !muted;
      video.muted = muted;
      syncMuteIcon();
    });
  }

  // ── Add to cart ───────────────────────────────────────────────────
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var variantId = atcBtn.dataset.variantId;
      if (!variantId) return;

      var original = atcBtn.textContent.trim();
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.id) {
            atcBtn.textContent = 'Added!';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (typeof window.GYMSKYNS_updateCartCount === 'function') {
              window.GYMSKYNS_updateCartCount();
            }
            // Same flow as every other add-to-cart: re-render the drawer with
            // the new item, close the reel, open the drawer.
            var refreshPromise = typeof window.GYMSKYNS_refreshCartDrawer === 'function'
              ? window.GYMSKYNS_refreshCartDrawer().catch(function () {})
              : Promise.resolve();
            refreshPromise.then(function () {
              setTimeout(function () {
                closeModal();
                var cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
              }, 600);
            });
            setTimeout(function () {
              atcBtn.disabled = false;
              atcBtn.textContent = original;
            }, 1800);
          } else {
            atcBtn.textContent = data.description || 'Error';
            setTimeout(function () {
              atcBtn.disabled = false;
              atcBtn.textContent = original;
            }, 2500);
          }
        })
        .catch(function () {
          atcBtn.textContent = 'Try again';
          setTimeout(function () {
            atcBtn.disabled = false;
            atcBtn.textContent = original;
          }, 2500);
        });
    });
  }

  // ── Events ────────────────────────────────────────────────────────
  trigger.addEventListener('click', openModal);
  if (closeBtn)  closeBtn.addEventListener('click', closeModal);
  if (backdrop)  backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
